var map = {
	"./anhang.md": [
		"b8c5",
		"chunk-2d210bbe"
	],
	"./en/anhang.md": [
		"b8d7",
		"chunk-2d210bdf"
	],
	"./en/legalnotice.md": [
		"3bfd",
		"chunk-2d0c4c83"
	],
	"./en/location.md": [
		"b247",
		"chunk-2d20ef89"
	],
	"./hisshi/0001.md": [
		"49ea",
		"chunk-2d0c26d7"
	],
	"./japan.md": [
		"9166",
		"chunk-2d0e48ce"
	],
	"./joseki/info.md": [
		"8b90",
		"chunk-2d0e8cb7"
	],
	"./joseki/info_en.md": [
		"93a5",
		"chunk-2d0e5584"
	],
	"./legalnotice.md": [
		"3e4b",
		"chunk-2d0c51b6"
	],
	"./location.md": [
		"1faa",
		"chunk-2d0b722b"
	],
	"./news/2018/2018-05-03-shogi-berlin-online.md": [
		"67c7",
		"chunk-2d0d07ab"
	],
	"./news/2018/2018-06-15-hanami-kirschblütenfest.md": [
		"aac9",
		"chunk-2d21314c"
	],
	"./news/2018/2018-06-15-tschechische-open-championship.md": [
		"d360",
		"chunk-2d21dc3f"
	],
	"./news/2018/2018-07-08-anmeldezahl-europäische-meisterschaft.md": [
		"74ba",
		"chunk-2d0d70d2"
	],
	"./news/2018/2018-07-08-sommerfest-der-deutsch-japanischen-gesellschaft.md": [
		"3dcd",
		"chunk-2d0c53a8"
	],
	"./news/2018/2018-10-03-aktualisierung.md": [
		"a63d",
		"chunk-2d208a3c"
	],
	"./news/2019/2019-03-13-mori-ogai-turnier.md": [
		"5556",
		"chunk-2d0c8637"
	],
	"./news/2019/2019-06-02-hausliga-rangliste-startet.md": [
		"b1b3",
		"chunk-2d20f156"
	],
	"./news/2019/2019-08-24-hausliga-3-runde.md": [
		"96ad",
		"chunk-2d0e60f6"
	],
	"./news/2019/2019-08-26-turnier-aktualisiert.md": [
		"653f",
		"chunk-2d0cfa88"
	],
	"./news/2019/2019-09-30-1-shogi-cup-sofia.md": [
		"bdf5",
		"chunk-2d21b147"
	],
	"./news/2019/2019-10-06-shogi-in-macha-macha.md": [
		"9a66",
		"chunk-2d0efcfe"
	],
	"./news/2019/2019-12-12-erste-shogianalyse-im-club.md": [
		"c363",
		"chunk-2d2167e3"
	],
	"./news/2019/2019-12-17-weihnachtsfeier.md": [
		"e22e",
		"chunk-2d224c96"
	],
	"./news/2020/2020-01-10-start-shogi-2020.md": [
		"9481",
		"chunk-2d0e544a"
	],
	"./news/2020/2020-02-05-flohmarkt.md": [
		"d885",
		"chunk-2d21ef47"
	],
	"./news/2020/2020-02-19-moriogai.md": [
		"3a1f",
		"chunk-2d0c4259"
	],
	"./news/2020/2020-06-13-start-shogi-again.md": [
		"846f",
		"chunk-2d0ddfe2"
	],
	"./news/2020/2020-07-11-wir-sind-umgezogen.md": [
		"5205",
		"chunk-2d0c7a58"
	],
	"./news/2020/2020-07-30-hausliga.md": [
		"49cc",
		"chunk-2d0c269b"
	],
	"./news/2021/2021-06-26-shogi-2021.md": [
		"180b",
		"chunk-2d0abf8f"
	],
	"./news/2021/2021-07-03-wosc-2021.md": [
		"a30a",
		"chunk-2d207e99"
	],
	"./news/2021/2021-07-04-odm-2021.md": [
		"800d",
		"chunk-2d0dd022"
	],
	"./news/2021/2021-07-06-profiwelt.md": [
		"41dc",
		"chunk-2d0c08b2"
	],
	"./news/2021/2021-09-25-dm-2021-result.md": [
		"f163",
		"chunk-2d22bd7e"
	],
	"./news/2021/2021-11-16-profiwelt.md": [
		"1b38",
		"chunk-2d0b5d6c"
	],
	"./news/2022/2022-02-14-profiwelt.md": [
		"e06f",
		"chunk-2d224591"
	],
	"./news/2022/2022-02-21-moriogai.md": [
		"797b",
		"chunk-2d0d7e63"
	],
	"./news/2022/2022-06-21-activity.md": [
		"4c5c",
		"chunk-2d0cbeb3"
	],
	"./news/2022/2022-08-01-wosc-berlin.md": [
		"5c3b",
		"chunk-2d0d32d3"
	],
	"./news/2022/2022-12-26-berlin-in-bremen.md": [
		"7eff",
		"chunk-2d0e2944"
	],
	"./news/2023/2023-01-16-year2023.md": [
		"27cd",
		"chunk-2d0b365c"
	],
	"./news/2023/2023-02-25-2nd-hausliga.md": [
		"071a",
		"chunk-2d0a478d"
	],
	"./news/2023/2023-02-25-8th-moriogai.md": [
		"550c",
		"chunk-2d0c85c9"
	],
	"./news/2023/2023-03-18-3rd-hausliga.md": [
		"f8ed",
		"chunk-2d22dda7"
	],
	"./news/2023/2023-04-15-shogi-evening.md": [
		"97aa",
		"chunk-2d0e64b4"
	],
	"./news/2023/2023-05-14-berlin-meet-italy.md": [
		"32c0",
		"chunk-2d0b97c2"
	],
	"./news/2023/2023-05-15-hausliga.md": [
		"cef4",
		"chunk-2d222966"
	],
	"./news/2023/2023-12-17-year-2023.md": [
		"a013",
		"chunk-2d207347"
	],
	"./news/2024/2024-03-16-mori-ogai-2024.md": [
		"7d11",
		"chunk-2d0e1ee3"
	],
	"./news/2024/2024-07-09-shogiwars.md": [
		"6340",
		"chunk-2d0cf2ef"
	],
	"./news/2024/2024-12-31-news.md": [
		"c50b",
		"chunk-2d216eda"
	],
	"./news/2025/2025-03-01-berliner-meister.md": [
		"86c1",
		"chunk-2d0deca2"
	],
	"./news/en/2018-05-03-shogi-berlin-online.md": [
		"5db9",
		"chunk-2d0d3c1c"
	],
	"./news/en/2019-09-30-1-shogi-cup-sofia.md": [
		"5d0a",
		"chunk-2d0d3636"
	],
	"./news/en/2019-10-06-shogi-in-macha-macha.md": [
		"07cf",
		"chunk-2d0a4da0"
	],
	"./news/en/2019-12-17-weihnachtsfeier.md": [
		"32de",
		"chunk-2d0b9816"
	],
	"./news/en/2020-01-10-start-shogi-2020.md": [
		"18a9",
		"chunk-2d0ac555"
	],
	"./news/en/2020-02-05-flohmarkt.md": [
		"d945",
		"chunk-2d21f28c"
	],
	"./news/en/2020-02-19-moriogai.md": [
		"b21a",
		"chunk-2d20ef56"
	],
	"./news/en/2021-06-26-shogi-2021.md": [
		"0292",
		"chunk-2d0a3591"
	],
	"./news/en/2021-07-03-wosc-2021.md": [
		"2c12",
		"chunk-2d0bd548"
	],
	"./news/en/2021-07-04-odm-2021.md": [
		"ab2a",
		"chunk-2d212f46"
	],
	"./news/en/2021-07-06-profiwelt.md": [
		"0ca3",
		"chunk-2d0af25b"
	],
	"./news/en/2021-09-25-dm-2021-result.md": [
		"c17d",
		"chunk-2d2160b1"
	],
	"./news/en/2022-02-14-profiwelt.md": [
		"995c",
		"chunk-2d0e66e4"
	],
	"./news/en/2022-02-21-moriogai.md": [
		"37e1",
		"chunk-2d0baac6"
	],
	"./news/en/2022-06-21-activity.md": [
		"bee8",
		"chunk-2d21b4ec"
	],
	"./news/en/2022-08-01-wosc-berlin.md": [
		"ac30",
		"chunk-2d2132f5"
	],
	"./news/en/2023-01-16-year2023.md": [
		"500c",
		"chunk-2d0c7304"
	],
	"./news/en/2023-02-25-8th-moriogai.md": [
		"1b57",
		"chunk-2d0b5da9"
	],
	"./news/en/2023-04-15-shogi-evening.md": [
		"8563",
		"chunk-2d0de370"
	],
	"./news/en/2023-05-14-berlin-meet-italy.md": [
		"6d48",
		"chunk-2d0daae8"
	],
	"./news/en/2023-05-15-hausliga.md": [
		"c117",
		"chunk-2d215fca"
	],
	"./news/en/2023-12-17-year-2023.md": [
		"5b6d",
		"chunk-2d0d2f71"
	],
	"./news/en/2024-03-16-mori-ogai-2024.md": [
		"957a",
		"chunk-2d0e581c"
	],
	"./news/en/2024-07-09-shogiwars.md": [
		"0de5",
		"chunk-2d0af69a"
	],
	"./news/en/2024-12-31-news.md": [
		"7ebb",
		"chunk-2d0e28c4"
	],
	"./news/en/2025-03-01-berliner-meister.md": [
		"055f",
		"chunk-2d0a408c"
	],
	"./privacystatement.md": [
		"979a",
		"chunk-2d0e5fdc"
	],
	"./shogi/berlinresult.md": [
		"d6c3",
		"chunk-2d21ecf8"
	],
	"./shogi/berlintournament2019.md": [
		"e0c5",
		"chunk-2d224ad3"
	],
	"./shogi/berlintournament2020.md": [
		"eb4a",
		"chunk-2d230100"
	],
	"./shogi/berlintournament2022.md": [
		"5fc6",
		"chunk-2d0d43ba"
	],
	"./shogi/berlintournament2023.md": [
		"9715",
		"chunk-2d0e5eb8"
	],
	"./shogi/berlintournament2024.md": [
		"828f",
		"chunk-2d0dd89e"
	],
	"./shogi/berlintournament2025.md": [
		"eb45",
		"chunk-2d2300d4"
	],
	"./shogi/berlintournament2026.md": [
		"03e3",
		"chunk-2d0a3ea7"
	],
	"./shogi/en/berlinresult.md": [
		"2c1a",
		"chunk-2d0bd577"
	],
	"./shogi/en/berlintournament2019.md": [
		"122d",
		"chunk-2d0aa949"
	],
	"./shogi/en/berlintournament2020.md": [
		"7dfd",
		"chunk-2d0e2581"
	],
	"./shogi/en/berlintournament2022.md": [
		"8f33",
		"chunk-2d0e9b04"
	],
	"./shogi/en/berlintournament2023.md": [
		"25a2",
		"chunk-2d0b2e6a"
	],
	"./shogi/en/berlintournament2024.md": [
		"ab9e",
		"chunk-2d213023"
	],
	"./shogi/en/berlintournament2025.md": [
		"4fc5",
		"chunk-2d0ccf5a"
	],
	"./shogi/en/berlintournament2026.md": [
		"0b84",
		"chunk-2d0ae9a4"
	],
	"./shogi/en/games.md": [
		"3068",
		"chunk-2d0b8ad5"
	],
	"./shogi/en/grundlagen.md": [
		"0bc2",
		"chunk-2d0aeed7"
	],
	"./shogi/en/handicap.md": [
		"1fef",
		"chunk-2d0b72ac"
	],
	"./shogi/en/moyu2022.md": [
		"dbc3",
		"chunk-2d229224"
	],
	"./shogi/en/moyu2023.md": [
		"7838",
		"chunk-2d0d79fc"
	],
	"./shogi/en/moyu2024.md": [
		"d619",
		"chunk-2d21e6f0"
	],
	"./shogi/en/moyu2025.md": [
		"48a4",
		"chunk-2d0c226d"
	],
	"./shogi/en/moyu2026.md": [
		"72aa",
		"chunk-2d0d6931"
	],
	"./shogi/en/ranking.md": [
		"c248",
		"chunk-2d2163e9"
	],
	"./shogi/en/shogi.md": [
		"51d1",
		"chunk-2d0c7cdf"
	],
	"./shogi/en/shogipro.md": [
		"d918",
		"chunk-2d21f232"
	],
	"./shogi/esc2018/blitzpairing.md": [
		"8e5a",
		"chunk-2d0e97af"
	],
	"./shogi/esc2018/blitzresult.md": [
		"6999",
		"chunk-2d0d0a19"
	],
	"./shogi/esc2018/day2.md": [
		"81de",
		"chunk-2d0dda30"
	],
	"./shogi/esc2018/day3.md": [
		"0bf6",
		"chunk-2d0aef38"
	],
	"./shogi/esc2018/day4.md": [
		"bdfb",
		"chunk-2d21b174"
	],
	"./shogi/esc2018/esc.md": [
		"7274",
		"chunk-2d0d63ee"
	],
	"./shogi/esc2018/pairing.md": [
		"cd44",
		"chunk-2d221f97"
	],
	"./shogi/esc2018/result.md": [
		"10e5",
		"chunk-2d0aa7c5"
	],
	"./shogi/games.md": [
		"73fa",
		"chunk-2d0d6d8d"
	],
	"./shogi/grundlagen.md": [
		"dba7",
		"chunk-2d2291ea"
	],
	"./shogi/handicap.md": [
		"d3c8",
		"chunk-2d21e1ba"
	],
	"./shogi/hausliga/2019/internalgames2019.md": [
		"7e63",
		"chunk-2d0e2341"
	],
	"./shogi/hausliga/2019/internalgames201906.md": [
		"15c1",
		"chunk-2d0aba48"
	],
	"./shogi/hausliga/2019/internalgames201907.md": [
		"522b",
		"chunk-2d0c7ac3"
	],
	"./shogi/hausliga/2019/internalgames201908.md": [
		"32bd",
		"chunk-2d0b97d7"
	],
	"./shogi/hausliga/2019/internalgames201909.md": [
		"5a0c",
		"chunk-2d0d2af5"
	],
	"./shogi/hausliga/2019/internalgames201910.md": [
		"aa94",
		"chunk-2d212c31"
	],
	"./shogi/hausliga/2019/internalgames201911.md": [
		"97c9",
		"chunk-2d0e64ca"
	],
	"./shogi/hausliga/2019/internalgames201912.md": [
		"0124",
		"chunk-2d0a30f9"
	],
	"./shogi/hausliga/2020/en/internalgames2020.md": [
		"1b78",
		"chunk-2d0b5de8"
	],
	"./shogi/hausliga/2020/en/internalgames202001.md": [
		"a198",
		"chunk-2d207805"
	],
	"./shogi/hausliga/2020/en/internalgames202007.md": [
		"2967",
		"chunk-2d0b383e"
	],
	"./shogi/hausliga/2020/en/internalgames202009.md": [
		"8e82",
		"chunk-2d0e97dd"
	],
	"./shogi/hausliga/2020/internalgames2020.md": [
		"eccf",
		"chunk-2d230a77"
	],
	"./shogi/hausliga/2020/internalgames202001.md": [
		"fedb",
		"chunk-2d238673"
	],
	"./shogi/hausliga/2020/internalgames202007.md": [
		"ca4d",
		"chunk-2d221484"
	],
	"./shogi/hausliga/2020/internalgames202009.md": [
		"3621",
		"chunk-2d0ba0d8"
	],
	"./shogi/hausliga/2023/en/internalgames2023.md": [
		"aea5",
		"chunk-2d21400e"
	],
	"./shogi/hausliga/2023/en/internalgames202301.md": [
		"db32",
		"chunk-2d228c53"
	],
	"./shogi/hausliga/2023/en/internalgames202302.md": [
		"e43a",
		"chunk-2d225433"
	],
	"./shogi/hausliga/2023/en/internalgames202303.md": [
		"9d24",
		"chunk-2d0f07c3"
	],
	"./shogi/hausliga/2023/en/internalgames202304.md": [
		"7244",
		"chunk-2d0d6391"
	],
	"./shogi/hausliga/2023/en/internalgames202305.md": [
		"62d8",
		"chunk-2d0cf506"
	],
	"./shogi/hausliga/2023/en/internalgames202306.md": [
		"0964",
		"chunk-2d0a4f7d"
	],
	"./shogi/hausliga/2023/en/internalgames202307.md": [
		"2b7f",
		"chunk-2d0bd275"
	],
	"./shogi/hausliga/2023/en/internalgames202308.md": [
		"938c",
		"chunk-2d0e50bb"
	],
	"./shogi/hausliga/2023/en/internalgames202309.md": [
		"07f3",
		"chunk-2d0a4dca"
	],
	"./shogi/hausliga/2023/en/internalgames202311.md": [
		"ea6c",
		"chunk-2d22fd7f"
	],
	"./shogi/hausliga/2023/en/internalgames202312.md": [
		"f457",
		"chunk-2d22c8a6"
	],
	"./shogi/hausliga/2023/internalgames2023.md": [
		"cd5e",
		"chunk-2d221fe7"
	],
	"./shogi/hausliga/2023/internalgames202301.md": [
		"24c3",
		"chunk-2d0b2ae8"
	],
	"./shogi/hausliga/2023/internalgames202302.md": [
		"5a4f",
		"chunk-2d0d2b74"
	],
	"./shogi/hausliga/2023/internalgames202303.md": [
		"bb15",
		"chunk-2d21a35a"
	],
	"./shogi/hausliga/2023/internalgames202304.md": [
		"29e3",
		"chunk-2d0b3deb"
	],
	"./shogi/hausliga/2023/internalgames202305.md": [
		"5772",
		"chunk-2d0c8df3"
	],
	"./shogi/hausliga/2023/internalgames202306.md": [
		"7a84",
		"chunk-2d0e147c"
	],
	"./shogi/hausliga/2023/internalgames202307.md": [
		"05e5",
		"chunk-2d0a462b"
	],
	"./shogi/hausliga/2023/internalgames202308.md": [
		"5c7d",
		"chunk-2d0d3351"
	],
	"./shogi/hausliga/2023/internalgames202309.md": [
		"8bf2",
		"chunk-2d0e922c"
	],
	"./shogi/hausliga/2023/internalgames202311.md": [
		"0d50",
		"chunk-2d0af0c5"
	],
	"./shogi/hausliga/2023/internalgames202312.md": [
		"4d66",
		"chunk-2d0cc266"
	],
	"./shogi/hausliga/2024/en/internalgames202305.md": [
		"fe80",
		"chunk-2d2380ed"
	],
	"./shogi/hausliga/2024/en/internalgames202306.md": [
		"38c5",
		"chunk-2d0bae4d"
	],
	"./shogi/hausliga/2024/en/internalgames202307.md": [
		"1fca",
		"chunk-2d0b7269"
	],
	"./shogi/hausliga/2024/en/internalgames202308.md": [
		"2f34",
		"chunk-2d0be0cb"
	],
	"./shogi/hausliga/2024/en/internalgames202309.md": [
		"4bd5",
		"chunk-2d0cc075"
	],
	"./shogi/hausliga/2024/en/internalgames202311.md": [
		"51b0",
		"chunk-2d0c7ca0"
	],
	"./shogi/hausliga/2024/en/internalgames202312.md": [
		"f36c",
		"chunk-2d22c530"
	],
	"./shogi/hausliga/2024/en/internalgames2024.md": [
		"9e2c",
		"chunk-2d0f0bb3"
	],
	"./shogi/hausliga/2024/en/internalgames202401.md": [
		"2d26",
		"chunk-2d0bd92c"
	],
	"./shogi/hausliga/2024/en/internalgames202402.md": [
		"2c31",
		"chunk-2d0bd585"
	],
	"./shogi/hausliga/2024/en/internalgames202403.md": [
		"866a",
		"chunk-2d0de75f"
	],
	"./shogi/hausliga/2024/internalgames202307.md": [
		"c948",
		"chunk-2d217e30"
	],
	"./shogi/hausliga/2024/internalgames202308.md": [
		"41dc4",
		"chunk-74750dc2"
	],
	"./shogi/hausliga/2024/internalgames202309.md": [
		"3dd3",
		"chunk-2d0c5396"
	],
	"./shogi/hausliga/2024/internalgames202311.md": [
		"aa06",
		"chunk-2d212b1c"
	],
	"./shogi/hausliga/2024/internalgames202312.md": [
		"91d3",
		"chunk-2d0e4e5d"
	],
	"./shogi/hausliga/2024/internalgames2024.md": [
		"d74c",
		"chunk-2d21eb38"
	],
	"./shogi/hausliga/2024/internalgames202401.md": [
		"9848",
		"chunk-2d0e62d9"
	],
	"./shogi/hausliga/2024/internalgames202402.md": [
		"1030",
		"chunk-2d0aa1b2"
	],
	"./shogi/hausliga/2024/internalgames202403.md": [
		"cd09",
		"chunk-2d221f20"
	],
	"./shogi/hausliga/2024/internalgames202405.md": [
		"e126",
		"chunk-2d2248a6"
	],
	"./shogi/hausliga/2024/internalgames202406.md": [
		"8ac9",
		"chunk-2d0e8e15"
	],
	"./shogi/moyu2022.md": [
		"640c",
		"chunk-2d0cf667"
	],
	"./shogi/moyu2023.md": [
		"5a5c",
		"chunk-2d0d2b90"
	],
	"./shogi/moyu2024.md": [
		"4543",
		"chunk-2d0c11b6"
	],
	"./shogi/moyu2025.md": [
		"5fda",
		"chunk-2d0d4404"
	],
	"./shogi/moyu2026.md": [
		"572d",
		"chunk-2d0c8d8a"
	],
	"./shogi/onlinetournament.md": [
		"cbb2",
		"chunk-2d221da5"
	],
	"./shogi/ranking.md": [
		"ac27",
		"chunk-2d2132dd"
	],
	"./shogi/shogi.md": [
		"74df",
		"chunk-2d0d7115"
	],
	"./shogi/shogipro.md": [
		"6093",
		"chunk-2d0ce84a"
	],
	"./tesuji/tesuji.md": [
		"98a2",
		"chunk-2d0e6846"
	],
	"./tsume/00002.md": [
		"0dd9",
		"chunk-2d0af67f"
	],
	"./tsume/00003.md": [
		"0d16",
		"chunk-2d0af04f"
	],
	"./tsume/0001.md": [
		"80a4",
		"chunk-2d0dd5e1"
	],
	"./tsume/en/00002.md": [
		"314f",
		"chunk-2d0b8e86"
	],
	"./tsume/en/00003.md": [
		"6399",
		"chunk-2d0cf393"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "05f2";
module.exports = webpackAsyncContext;